import React from "react";
import Button from "@mui/material/Button";
//import { api } from "../../utils";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";

export default function NewsletterSignupModal(props) {
  const handleClose = () => {
    props.close(false);
  };

  function submit() {
    //api.post("https://hooverandstrong.us2.list-manage.com/subscribe/post?u=a84676575358f6c6855acaba5&amp;id=6d5969c4ea")
  }

  return (
    <Dialog open={props.open} onClose={handleClose}>
      <DialogTitle>Subscribe to our Newsletter!</DialogTitle>
      <DialogContent>
        <DialogContentText>
          To subscribe to our newsletter, please enter your email address here.
          <TextField
            autoFocus
            name="EMAIL"
            id="name"
            type="email"
            fullWidth
            color="primary"
            size="small"
            sx={{ marginTop: "2rem" }}
            label={<Typography variant="navText">Email Address</Typography>}
          />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="contained" color="success" onClick={() => submit()}>
          Subscribe
        </Button>
      </DialogActions>
    </Dialog>
  );
}
